import { componentInterface } from '@ardoq/component-interface';
import type { RelationshipsLink, RelationshipsNode } from '../types';
import { descendantsForEach } from '../util';
import type { ViewLoadMetrics } from 'tracking/durationTracking/types';

type GetPerformanceTrackingDataArgs = {
  rootNode: RelationshipsNode | null;
  links: RelationshipsLink[];
};

export const getPerformanceTrackingData = ({
  rootNode,
  links,
}: GetPerformanceTrackingDataArgs): ViewLoadMetrics => {
  if (!rootNode) {
    return { componentCount: 0, referenceCount: 0, workspaceCount: 0 };
  }

  let componentCount = 0;
  const workspaceIds = new Set<string>();

  descendantsForEach(rootNode, node => {
    if (node.isSynthetic || !node.modelId) {
      return;
    }
    componentCount += 1;
    const workspaceId = componentInterface.getWorkspaceId(node.modelId);
    if (workspaceId) {
      workspaceIds.add(workspaceId);
    }
  });

  return {
    componentCount,
    referenceCount: links.length,
    workspaceCount: workspaceIds.size,
  };
};
